import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardActionArea from '@material-ui/core/CardActionArea';

import ChevronRightIcon from '@material-ui/icons/ArrowForwardIosOutlined';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class TileLink extends React.Component {
  render() {
    const { classes, title, content, icon, action } = this.props;

    const Icon = icon;

    return (
      <Card className={classes.root} onClick={action}>
        <CardActionArea>
          <div className={classes.content}>
            <div className={classes.left}>
              <Icon className={`${classes.avatarBase} ${classes.avatar}`} />
              <div>
                <Typography
                  component='h4'
                  variant='h4'
                  className={classes.heading}
                >
                  {title}
                </Typography>
                {content ? <div className={classes.body}>{content}</div> : null}
              </div>
            </div>
            <div>
              <ChevronRightIcon className={classes.chevron} />
            </div>
          </div>
        </CardActionArea>
      </Card>
    );
  }
}

TileLink.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object,
  icon: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
};

TileLink.defaultProps = {
  content: null,
};

export default withStyles(styles)(TileLink);
